/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrosshair = createReactComponent("crosshair", "IconCrosshair", [
  ["path", { d: "M4 8v-2a2 2 0 0 1 2 -2h2", key: "svg-0" }],
  ["path", { d: "M4 16v2a2 2 0 0 0 2 2h2", key: "svg-1" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "svg-2" }],
  ["path", { d: "M16 20h2a2 2 0 0 0 2 -2v-2", key: "svg-3" }],
  ["path", { d: "M9 12l6 0", key: "svg-4" }],
  ["path", { d: "M12 9l0 6", key: "svg-5" }]
]);

export { IconCrosshair as default };
//# sourceMappingURL=IconCrosshair.js.map
